import Swal from 'sweetalert2';

// Create a global Swal instance with overridden button text
export const swal = Swal.mixin({
  confirmButtonText: 'Aceptar',
  cancelButtonText: 'Cancelar',
  showConfirmButton: true,
  showCancelButton: false,
});

// Create a global Swal instance with overridden button text
export const DeleteAlert = Swal.mixin({
  confirmButtonText: 'Eliminar',
  cancelButtonText: 'Cancelar',
  confirmButtonColor: '#BB1010',
  showConfirmButton: true,
  showCancelButton: true,
});

export const alert = Swal.mixin({
  showConfirmButton: false,
  showCancelButton: false,
  timer: 3000
});
